var render = function render(){var _vm=this,_c=_vm._self._c;return (true)?_c('div',{staticClass:"main-layout"},[_c('SideBar'),_c('div',{staticClass:"page"},[_c('router-view')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }